export async function useArticle(apiId: string):any {
    const gql = useGql();
    const res = await gql<any>('findArticle', {id: apiId});

    return computed(() => {
        const a = res.article;
        if (!a) return null;

        return {
            ...a,
            images: a.images?.edges?.map((e: any) => e?.node).filter(Boolean) ?? [],
            drawings: a.drawings?.edges?.map((e: any) => e?.node).filter(Boolean) ?? [],
            categories: a.categories?.edges?.map((e: any) => e?.node).filter(Boolean) ?? [],
        };
    });
}
